/*
 *
 * CollaboratorsSummary reducer
 *
 */

import { fromJS } from "immutable"
import {
  GET_COLLABORATORS_SUMMARY_WATCHER,
  GET_COLLABORATORS_SUMMARY_SUCCESS,
  GET_COLLABORATORS_SUMMARY_FAILED,
  SAVE_EXCEL_COLLABORATORS_PROGRESS,
  SAVE_EXCEL_COLLABORATORS_FAILED,
  GET_CEASED_SUMMARY_WATCHER,
  GET_CEASED_SUMMARY_SUCCESS,
  GET_CEASED_SUMMARY_FAILED,
  SAVE_EXCEL_CEASED_PROGRESS,
  SAVE_EXCEL_CEASED_WATCHER,
  SAVE_EXCEL_COLLABORATORS_WATCHER,
  GET_DIVISIONS_ASSIGNMENT_SUMMARY_WATCHER,
  GET_DIVISIONS_ASSIGNMENT_SUMMARY_SUCCESS,
  GET_DIVISIONS_ASSIGNMENT_SUMMARY_FAILED,
  SAVE_EXCEL_DIVISIONS_ASSIGNMENT_WATCHER,
  SAVE_EXCEL_DIVISIONS_ASSIGNMENT_PROGRESS,
  GET_TEAMS_SUMMARY_WATCHER,
  GET_TEAMS_SUMMARY_SUCCESS,
  GET_TEAMS_SUMMARY_FAILED,
  SAVE_EXCEL_TEAMS_WATCHER,
  SAVE_EXCEL_TEAMS_PROGRESS,
} from "./constants"

export const initialState = fromJS({
  isLoadingSummary: true,
  summary: [],
  percentage: 0,
  error: false,
})

function collaboratorsSummaryReducer(state = initialState, action) {
  switch (action.type) {
    case SAVE_EXCEL_COLLABORATORS_WATCHER:
      return state.set("percentage", 0).set("error", false)
    case SAVE_EXCEL_CEASED_WATCHER:
    case SAVE_EXCEL_DIVISIONS_ASSIGNMENT_WATCHER:
    case SAVE_EXCEL_TEAMS_WATCHER:
      return state.set("percentage", 0)
    case SAVE_EXCEL_COLLABORATORS_PROGRESS:
    case SAVE_EXCEL_CEASED_PROGRESS:
    case SAVE_EXCEL_TEAMS_PROGRESS:
    case SAVE_EXCEL_DIVISIONS_ASSIGNMENT_PROGRESS:
      return state.set("percentage", action.payload)
    case SAVE_EXCEL_COLLABORATORS_FAILED:
      return state.set("error", true)
    case GET_COLLABORATORS_SUMMARY_WATCHER:
      return state.set("isLoadingSummary", true).set("summary", [])
    case GET_COLLABORATORS_SUMMARY_SUCCESS:
      return state.set("isLoadingSummary", false).set("summary", action.payload)
    case GET_COLLABORATORS_SUMMARY_FAILED:
      return state.set("isLoadingSummary", false).set("summary", [])
    case GET_CEASED_SUMMARY_WATCHER:
      return state.set("isLoadingSummary", true).set("summary", [])
    case GET_CEASED_SUMMARY_SUCCESS:
      return state.set("isLoadingSummary", false).set("summary", action.payload)
    case GET_CEASED_SUMMARY_FAILED:
      return state.set("isLoadingSummary", false).set("summary", [])
    case GET_DIVISIONS_ASSIGNMENT_SUMMARY_WATCHER:
      return state.set("isLoadingSummary", true).set("summary", [])
    case GET_DIVISIONS_ASSIGNMENT_SUMMARY_SUCCESS:
      return state.set("isLoadingSummary", false).set("summary", action.payload)
    case GET_DIVISIONS_ASSIGNMENT_SUMMARY_FAILED:
    case GET_TEAMS_SUMMARY_WATCHER:
      return state.set("isLoadingSummary", true).set("summary", [])
    case GET_TEAMS_SUMMARY_SUCCESS:
      return state.set("isLoadingSummary", false).set("summary", action.payload)
    case GET_TEAMS_SUMMARY_FAILED:
      return state.set("isLoadingSummary", false).set("summary", [])
    default:
      return state
  }
}

export default collaboratorsSummaryReducer
